import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { ProjectorPage } from "@/features/projection/projector-page";

/**
 * PROJECTOR OUTPUT (F2). Intentionally public (guest-first): projector
 * can be an account-less browser — only renders what presenter
 * (authorized on THEIR device) pushes via P2P-LAN or BroadcastChannel.
 * `?local=1` = second window on same device.
 */
function ProjectorRoutePage() {
  const local = new URLSearchParams(globalThis.location.search).get("local") === "1";
  return <ProjectorPage local={local} />;
}

export const projectorRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/projector",
  component: ProjectorRoutePage,
});
